import {
    COOKIE_EXPIRATION_DAYS,
    COOKIE_MODE,
} from '@marketplace/config/cookie.js'
import { USER_UPDATE_MUTATION } from '@marketplace/graphql/account.js'
import { unlocalizeRouteName } from '@marketplace/helpers/router.js'
import Cookies from 'js-cookie'

/**
 * Update the visit cookie when changing pages so the cookie lifetime is extended.
 *
 * @param {object} context
 * @param redirect
 * @param app
 */
export default function (context) {
    const currentRouteName = unlocalizeRouteName(context.route.name)
    const isLoggedIn = context.app.$helpers.isLoggedIn
    const excludedPrefixes = ['auth-', 'ds-signup-']
    const hasDropshipping = context.store.getters['global/account']
    const hasOneBrandFeature =
        context.store.getters['feature/hasOneBrandFeature']
    const isExcludedPage = excludedPrefixes.some((path) =>
        currentRouteName?.startsWith(path)
    )

    if (
        !hasDropshipping ||
        !isLoggedIn ||
        isExcludedPage ||
        (currentRouteName === 'home' &&
            context.from?.path === '/' &&
            !hasOneBrandFeature)
    ) {
        return
    }

    const isDropshippingPage = currentRouteName?.startsWith('ds')
    const currentMode = Cookies.get(COOKIE_MODE)

    const mode = isDropshippingPage ? 'dropshipping' : 'marketplace'

    if (mode !== currentMode) {
        context.store.commit('global/updateUserLastVisitedEnvironment', mode)

        const client = context.app.apolloProvider.defaultClient
        client
            .mutate({
                mutation: USER_UPDATE_MUTATION,
                variables: {
                    lastVisitedEnvironment: mode,
                },
            })
            .then(({ data }) => {})
    }

    if (
        hasOneBrandFeature &&
        (currentRouteName === 'ds' || !currentRouteName.startsWith('ds'))
    ) {
        return context.redirect(
            context.app.localePath({ name: 'ds-import-list' })
        )
    }

    Cookies.set(COOKIE_MODE, mode, {
        expires: COOKIE_EXPIRATION_DAYS.ONE_YEAR,
        path: '/', // Specifically set the path because the defaults aren't used when updating a cookie
    })
}
